/** Canonical public site origin (no trailing slash). Used for meta, JSON-LD, OG URLs. */
const DEFAULT_ORIGIN = "https://www.novelnet.co.uk";

export function getSiteOrigin() {
  const raw = (import.meta.env.VITE_BASE_URL || DEFAULT_ORIGIN).trim();
  return raw.replace(/\/+$/, "");
}

/**
 * Absolute URL for meta and schema. Pass a path (`/books/123`) or already-absolute URL.
 */
export function absoluteUrl(pathOrUrl) {
  if (pathOrUrl == null || pathOrUrl === "") return "";
  const s = String(pathOrUrl).trim();
  if (/^https?:\/\//i.test(s)) return s;
  const origin = getSiteOrigin();
  const path = s.startsWith("/") ? s : `/${s}`;
  return `${origin}${path}`;
}

export const defaultSiteTitle =
  "NovelNet - Modern Book Tracking & Social Reading Platform";

export const defaultSiteDescription =
  "Track your reading progress, discover new books, and connect with fellow readers.";

export const defaultOgLocale = "en_GB";
